export var ISignUpRequest;
(function (ISignUpRequest) {
    let IAnnualSales;
    (function (IAnnualSales) {
        /**
         * Return an instance of IAnnualSales with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IAnnualSales.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IAnnualSales = ISignUpRequest.IAnnualSales || (ISignUpRequest.IAnnualSales = {}));
    let IAnnualInventoryVolume;
    (function (IAnnualInventoryVolume) {
        /**
         * Return an instance of IAnnualInventoryVolume with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IAnnualInventoryVolume.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IAnnualInventoryVolume = ISignUpRequest.IAnnualInventoryVolume || (ISignUpRequest.IAnnualInventoryVolume = {}));
    /**
     * A user's preference for a certain type of email, such as marketing emails.
     */
    let EmailPreference;
    (function (EmailPreference) {
        /**
         * We should send emails of a certain type to the user.
         */
        EmailPreference["OPTED_IN"] = "OPTED_IN";
        /**
         * We should not send emails of a certain type to the user.
         */
        EmailPreference["OPTED_OUT"] = "OPTED_OUT";
        /**
         * The user has not decided on a preference, we should prompt them at a later time.
         */
        EmailPreference["UNDECIDED"] = "UNDECIDED";
    })(EmailPreference = ISignUpRequest.EmailPreference || (ISignUpRequest.EmailPreference = {}));
    /**
     * A user's preference for receiving a certain type of text messages (sms)
     */
    let SmsPreference;
    (function (SmsPreference) {
        SmsPreference["SMS_PREFERENCE_UNKNOWN"] = "SMS_PREFERENCE_UNKNOWN";
        SmsPreference["SMS_PREFERENCE_OPTED_IN"] = "SMS_PREFERENCE_OPTED_IN";
        SmsPreference["SMS_PREFERENCE_OPTED_OUT"] = "SMS_PREFERENCE_OPTED_OUT";
        SmsPreference["SMS_PREFERENCE_UNDECIDED"] = "SMS_PREFERENCE_UNDECIDED";
    })(SmsPreference = ISignUpRequest.SmsPreference || (ISignUpRequest.SmsPreference = {}));
    /**
     * A user's preference for their business platform
     */
    let BusinessPlatform;
    (function (BusinessPlatform) {
        BusinessPlatform["BUSINESS_PLATFORM_UNKNOWN"] = "BUSINESS_PLATFORM_UNKNOWN";
        BusinessPlatform["BRICK_AND_MORTAR"] = "BRICK_AND_MORTAR";
        BusinessPlatform["ONLINE_ONLY"] = "ONLINE_ONLY";
        BusinessPlatform["POP_UP"] = "POP_UP";
        BusinessPlatform["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    })(BusinessPlatform = ISignUpRequest.BusinessPlatform || (ISignUpRequest.BusinessPlatform = {}));
    let ShopifyBusinessPlatform;
    (function (ShopifyBusinessPlatform) {
        ShopifyBusinessPlatform["SHOPIFY_BUSINESS_PLATFORM_UNKNOWN"] = "SHOPIFY_BUSINESS_PLATFORM_UNKNOWN";
        ShopifyBusinessPlatform["ONLINE_STORE"] = "ONLINE_STORE";
        ShopifyBusinessPlatform["IN_PERSON"] = "IN_PERSON";
        ShopifyBusinessPlatform["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
        ShopifyBusinessPlatform["OTHER"] = "OTHER";
    })(ShopifyBusinessPlatform = ISignUpRequest.ShopifyBusinessPlatform || (ISignUpRequest.ShopifyBusinessPlatform = {}));
    let NumPhysicalStoresDescriptionOption;
    (function (NumPhysicalStoresDescriptionOption) {
        NumPhysicalStoresDescriptionOption["NUM_PHYSICAL_STORES_DESCRIPTION_OPTION_UNKNOWN"] = "NUM_PHYSICAL_STORES_DESCRIPTION_OPTION_UNKNOWN";
        NumPhysicalStoresDescriptionOption["ONE"] = "ONE";
        NumPhysicalStoresDescriptionOption["TWO"] = "TWO";
        NumPhysicalStoresDescriptionOption["THREE"] = "THREE";
        NumPhysicalStoresDescriptionOption["FOUR_OR_MORE"] = "FOUR_OR_MORE";
    })(NumPhysicalStoresDescriptionOption = ISignUpRequest.NumPhysicalStoresDescriptionOption || (ISignUpRequest.NumPhysicalStoresDescriptionOption = {}));
    /**
     * Return an instance of ISignUpRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ISignUpRequest.build = (partial) => (Object.assign({ attributions: [], sales_methods: [], pre_sign_up_activities: [], business_platforms: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ISignUpRequest || (ISignUpRequest = {}));
